import ACTIONS from "../../constants/actions";

const initialState = {
	id     : 0,
	isAuth : false,
	money  : 0
};

export default function auth(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.AUTH.IS_AUTH:
			return Object.assign({}, {...action.data});
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/auth.js